import { render, staticRenderFns } from "./ChannelsTable.vue?vue&type=template&id=e920fafc&"
import script from "./ChannelsTable.vue?vue&type=script&lang=js&"
export * from "./ChannelsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports